import React, { Component } from 'react'
import axios from 'axios'
import ReCAPTCHA from "react-google-recaptcha"
import { Link } from "react-router-dom"
import { Redirect } from "react-router-dom"

import "bootstrap/dist/css/bootstrap.min.css"

const recaptchaRef = React.createRef()

class Login extends Component {
  constructor() {
    super()
    this.state = {
      email: "",
      password: "",
      loggedIn: false
    }
    this.changeEmail = this.changeEmail.bind(this)
    this.changePassword = this.changePassword.bind(this)
    this.onSubmit = this.onSubmit.bind(this)
    this.onChange = this.onChange.bind(this)
  }
  changeEmail(event) {
    this.setState({
      email: event.target.value
    })
  }
  changePassword(event) {
    this.setState({
      password: event.target.value
    })
  }
  onSubmit(event) {
    event.preventDefault()
    if (true === true) {
      const registered = {
        email: this.state.email,
        password: this.state.password
      }
      axios.post('http://localhost:4000/app/login', registered)
        .then(response => {
          console.log("login response", response)
          if (response.data.value = 1) {
            alert("Email doesn't exist")
          }
          else if (response.data.value = 2) {
            alert("Password is incorrect")
          }
          else if (response.status === 200) {
            this.setState({ loggedIn: true })
            alert(`"${registered.email} successfully logged in"`)
          }
        })
        .catch(error => {
          alert("Something went wrong, please send an email to logan@seatstir.com")
        })
    }
    else {
      alert("Please prove you're not a robot")
    }
  }
  onChange(value) {
    const recaptchaValue = recaptchaRef.current.getValue();
    if (value === recaptchaValue) {
      this.setState({
        human: true
      })
    }
  }


  render() {
    if (this.state.loggedIn) {
      return <Redirect to={{ pathname: "/" }} />
    }
    return (
      <div>
        <div className="enter-form-container enter-sign-in-container">
          <form className="enter-form" action="#" onSubmit={this.onSubmit}>
            <h1>Member Login</h1>
            <div className="social-container">
              <a className="enter-a" href="#" className="social"><i className="fab fa-facebook-f"></i></a>
              <a className="enter-a" href="#" className="social"><i className="fab fa-google-plus-g"></i></a>
              <a className="enter-a" href="#" className="social"><i className="fab fa-linkedin-in"></i></a>
            </div>
            <span>Or with your account</span>
            <input className="loginInput enter-input" type="email" placeholder="Email" autoFocus onChange={this.changeEmail} value={this.state.email} required />
            <input className="loginInput enter-input" type="password" placeholder="Password" required placeholder="Password" onChange={this.changePassword} value={this.state.password} />
            <a className="enter-a" href="#">Forgot your password?</a>
            <button className="enter-button">Sign In</button>
          </form>
        </div>
      </div >
    )
  }
}

export default Login